import { useEffect, useRef, useState } from "react";
import "../variable.css";

export const useAxisLabelFontStyle = () => {
  const chartRef = useRef(null);
  const [fontSize, setFontSize] = useState("12px");

  useEffect(() => {
    const updateFontSize = () => {
      const width = chartRef.current?.offsetWidth || 0;
      if (width < 800) setFontSize("12px");
      else if (width < 1200) setFontSize("12px");
      else setFontSize("12px");
    };

    updateFontSize();
    window.addEventListener("resize", updateFontSize);
    return () => window.removeEventListener("resize", updateFontSize);
  }, []);

  const axisLabelFontStyle = {
    fontFamily: "Inter",
    fontSize,
    fontWeight: 400,
    colors: "var(--Parimitives-Charts-charts-Text)",
  };

  return { axisLabelFontStyle, chartRef };
};
